import React, { useState, useEffect } from 'react';
import '../styles/Hero.css';

export default function Hero() {
  const [bio, setBio] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/bio')
      .then(res => res.json())
      .then(data => {
        setBio(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  if (loading) return null;

  return (
    <section className="hero">
      <div className="hero-content">
        <h1>{bio?.name}</h1>
        <p className="hero-title">{bio?.title}</p>
        <p className="hero-summary">{bio?.summary}</p>
        <div className="hero-buttons">
          <button className="btn btn-primary" onClick={() => document.getElementById('projects').scrollIntoView()}>View Projects</button>
          <button className="btn btn-secondary" onClick={() => document.getElementById('experience').scrollIntoView()}>My Experience</button>
        </div>
      </div>
    </section>
  );
}
